const Footer = () => {
  return (
    <footer className="w-full py-16 bg-white border-t border-slate-100 mt-20">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-sm text-slate-500">
          {/* Col 1: Brand */}
          <div className="space-y-4">
            <div className="space-y-1 pt-1">
              <p className="font-semibold text-slate-800">Colegio de Abogados de Lomas de Zamora</p>
              <p>Palacio de Justicia de Lomas de Zamora</p>
              <p>Larroque 2360, Banfield</p>
            </div>
          </div>

          {/* Col 2: Contact */}
          <div className="space-y-4">
            <h4 className="text-primary-900 font-bold text-base uppercase tracking-[0.2em]">Atención</h4>
            <div className="space-y-2">
              <p>Lunes a Viernes 8:00 a 16:00 hs</p>
              <div className="pt-2">
                <p className="flex items-center">
                  <span className="w-20 inline-block font-medium text-slate-700">Tel:</span>
                  <span>(011) 4202-0962</span>
                </p>
                <p className="flex items-center">
                  <span className="w-20 inline-block font-medium text-slate-700">WhatsApp:</span>
                  <a href="https://wa.me/5491158587592" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline tracking-tight">(+54 9 11) 5858-7592</a>
                </p>
                <p className="flex items-center">
                  <span className="w-20 inline-block font-medium text-slate-700">Email:</span>
                  <a href="mailto:consultas@calz.org" className="text-primary-600 hover:underline">consultas@calz.org</a>
                </p>
              </div>
            </div>
          </div>

          {/* Col 3: Social */}
          <div className="space-y-4">
            <h4 className="text-primary-900 font-bold text-base uppercase tracking-[0.2em]">Seguinos</h4>
            <div className="flex flex-wrap gap-x-6 gap-y-3">
              <a href="https://calz.org.ar" target="_blank" rel="noopener noreferrer" className="hover:text-primary-800 transition-colors font-medium border-b border-transparent hover:border-primary-200">Web Oficial</a>
              <a href="https://www.instagram.com/calzlomas" target="_blank" rel="noopener noreferrer" className="hover:text-primary-800 transition-colors font-medium border-b border-transparent hover:border-primary-200">Instagram</a>
              <a href="https://www.facebook.com/CALZLOMAS" target="_blank" rel="noopener noreferrer" className="hover:text-primary-800 transition-colors font-medium border-b border-transparent hover:border-primary-200">Facebook</a>
              <a href="https://www.youtube.com/c/CALZTVlomas" target="_blank" rel="noopener noreferrer" className="hover:text-primary-800 transition-colors font-medium border-b border-transparent hover:border-primary-200">YouTube</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-[0.3em] font-medium text-slate-400">
          <span>&copy; {new Date().getFullYear()} Colegio de Abogados Lomas de Zamora</span>
          <span className="text-primary-900 opacity-30 italic">Buscador Institucional • Versión 2.0</span>
          <span className="text-[9px] opacity-40">
            Desarrollado por <a href="https://www.instagram.com/_ejecreativo" target="_blank" rel="noopener noreferrer" className="font-bold hover:text-primary-600 transition-colors">EJE CREATIVO</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;